import React, { useState, useContext } from 'react';
import GithubContext from '../../context/github/githubContext';
import AlertContext from '../../context/alert/alertContext';

const Search = () => {
  const githubContext = useContext(GithubContext);
  const alertContext = useContext(AlertContext);

  const [text, setText] = useState('');

  const onSubmit = e => {
    e.preventDefault();
    if (text === '') {
      alertContext.setAlert('Please enter something', 'light');
    } else {
      githubContext.searchUsers(text);
      setText('');
    }
  };

  const onChange = e => setText(e.target.value);

  return (
    <div>
      <form onSubmit={onSubmit} className="form">
        <label htmlFor="search-user" className="hidden">
          <h2>Search for Users</h2>
        </label>
        <p id="search-desc">
          Enter a user you would like to search for in Github's database of
          users.
        </p>
        <div className="search">
          <input
            aria-describedby="search-desc"
            className="form__input"
            id="search-user"
            type="text"
            name="search"
            placeholder="Search Users..."
            value={text}
            onChange={onChange}
          />
          <button type="submit" className="form__btn">
            Search
          </button>
          {githubContext.users.length > 0 && (
            <button
              className="form__btn form__btn--light"
              onClick={githubContext.clearUsers}
            >
              Clear
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Search;
